<template>
    <div id='purchase_fail_modal' class="modal">
        <div class="modal-background"></div>
        <div class="modal-card">
            <header class="modal-card-head">
                <p class="modal-card-title">Incomplete purchases</p>
                <button class="delete" aria-label="close" @click="doClose()"></button>
            </header>
            <section class="modal-card-body">
                <ul style="margin:2em auto; font-weight:bold;" id='purchase_fail_list'></ul>
                <div>Please submit the above purchases before continuing.</div>
            </section>
            <footer class="modal-card-foot">
                <button class="button is-success" @click="doClose()">
                    Edit
                </button>
            </footer>
        </div>
    </div>
</template>

<script>
export default {
    name: "PurchaseFailModal",
    methods: {
        doClose() {
            this.$emit('doClose')
        }
    }
};
</script>